export default class FilStorage {
  constructor() {
    this.storageEnabled();
  }

  storageEnabled() {
    this.isStorageEnabled = false;
    try {
      window.localStorage ? (this.isStorageEnabled = true) : (this.isStorageEnabled = false);
    } catch (error) {
      window.localStorage = {
        setItem: function() {},
        getItem: function() {},
      };
      window.sessionStorage = {
        setItem: function() {},
        getItem: function() {},
      };
      this.isStorageEnabled = false;
      throw 'LocalStorage and SessionStorage is not supported on this browser. It could possibly be running in private or incognito mode';
    }
    return this.isStorageEnabled;
  }

  setLocalItem(key, value, encryption) {
    if (this.isStorageEnabled) {
      if (encryption) {
        var encodedKey = Base64.encode(key);
        var encodedValue = Base64.encode(value);
        localStorage.setItem(encodedKey, encodedValue);
      } else {
        localStorage.setItem(key, value);
      }
    } else {
      // throw exception
    }
  }

  getLocalItem(key, encryption) {
    var returnValue = null;
    var retrievedKey = null;
    if (this.isStorageEnabled) {
      if (encryption) {
        var encodedKey = Base64.encode(key);
        retrievedKey = localStorage.getItem(encodedKey);
        if (retrievedKey) {
          returnValue = Base64.decode(retrievedKey);
        }
      } else {
        returnValue = localStorage.getItem(key);
      }
    } else {
      // throw exception
    }
    return returnValue;
  }

  getAllItems(encryption) {
    var returnValue = [];
    if (this.isStorageEnabled) {
      var keys = Object.keys(localStorage);
      var i = keys.length;
      while (i--) {
        if (encryption) {
          returnValue.push(Base64.decode(localStorage.getItem(keys[i])));
        } else {
          returnValue.push(localStorage.getItem(keys[i]));
        }
      }
    } else {
      // throw exception
    }
    return returnValue;
  }

  removeItem(key, encryption) {
    if (this.isStorageEnabled) {
      if (encryption) {
        var encodedKey = Base64.encode(key);
        localStorage.removeItem(encodedKey);
      } else {
        localStorage.removeItem(key);
      }
    } else {
      // throw exception
    }
  }

  removeAllLocalItem() {
    if (this.isStorageEnabled) {
      localStorage.clear();
    } else {
      // throw exception
    }
  }

  setSessionItem(key, value, encryption) {
    if (this.isStorageEnabled) {
      if (encryption) {
        var encodedKey = Base64.encode(key);
        var encodedValue = Base64.encode(value);
        sessionStorage.setItem(encodedKey, encodedValue);
      } else {
        sessionStorage.setItem(key, value);
      }
    } else {
      // throw exception
    }
  }

  getSessionItem(key, encryption) {
    var returnValue = null;
    var retrievedKey = null;
    if (this.isStorageEnabled) {
      if (encryption) {
        var encodedKey = Base64.encode(key);
        retrievedKey = sessionStorage.getItem(encodedKey);
        if (retrievedKey) {
          returnValue = Base64.decode(retrievedKey);
        }
      } else {
        returnValue = sessionStorage.getItem(key);
      }
    } else {
      // throw exception
    }
    return returnValue;
  }

  removeSessionItem(key, encryption) {
    if (this.isStorageEnabled) {
      if (encryption) {
        var encodedKey = Base64.encode(key);
        sessionStorage.removeItem(encodedKey);
      } else {
        sessionStorage.removeItem(key);
      }
    } else {
      // throw exception
    }
  }

  removeAllSessionItem() {
    if (this.isStorageEnabled) {
      sessionStorage.clear();
    } else {
      // throw exception
    }
  }
}

const _KEYSTR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

class Base64 {
  static encode(input) {
    var output = '';
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = Base64._utf8_encode(input);
    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;
      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output =
        output +
        _KEYSTR.charAt(enc1) +
        _KEYSTR.charAt(enc2) +
        _KEYSTR.charAt(enc3) +
        _KEYSTR.charAt(enc4);
    }
    return output;
  }

  // public method for decoding
  static decode(input) {
    var output = '';
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;
    input = input.replace(/[^A-Za-z0-9+/=]/g, '');
    while (i < input.length) {
      enc1 = _KEYSTR.indexOf(input.charAt(i++));
      enc2 = _KEYSTR.indexOf(input.charAt(i++));
      enc3 = _KEYSTR.indexOf(input.charAt(i++));
      enc4 = _KEYSTR.indexOf(input.charAt(i++));
      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;
      output = output + String.fromCharCode(chr1);
      if (enc3 !== 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 !== 64) {
        output = output + String.fromCharCode(chr3);
      }
    }
    output = Base64._utf8_decode(output);
    return output;
  }

  // private method for UTF-8 encoding
  static _utf8_encode(string) {
    string = string.replace(/\r\n/g, '\n');
    var utftext = '';
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }
    }
    return utftext;
  }

  // private method for UTF-8 decoding
  static _utf8_decode(utftext) {
    var string = '';
    var i = 0;
    var c, c2, c3;
    c = c2 = 0;
    while (i < utftext.length) {
      c = utftext.charCodeAt(i);
      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1);
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      } else {
        c2 = utftext.charCodeAt(i + 1);
        c3 = utftext.charCodeAt(i + 2);
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        i += 3;
      }
    }
    return string;
  }
}



// WEBPACK FOOTER //
// ./src/lib/FilStorage.js